import { Stack, Typography } from "@mui/material";
import { FC } from "react";

interface RecommendationItemProps {
  label: string;
  description?: string;
}

const RecommendationItem: FC<RecommendationItemProps> = ({ label, description, ...props }) => {
  return (
    <Stack m={1}>
      <Typography fontWeight={"bold"} variant="subtitle2">
        {label}
      </Typography>
      {description && (
        <Typography ml={1} variant="subtitle1">
          {description}
        </Typography>
      )}
      {props.children}
    </Stack>
  );
};

export default RecommendationItem;
